import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import nb from './locales/nb.json'
import de from './locales/de.json'
import fr from './locales/fr.json'

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'nb', label: 'Norsk' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
] as const

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    nb: { translation: nb },
    de: { translation: de },
    fr: { translation: fr },
  },
  lng: navigator.language.startsWith('nb')
    ? 'nb'
    : navigator.language.startsWith('de')
      ? 'de'
      : navigator.language.startsWith('fr')
        ? 'fr'
        : 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
